import { useNavigate } from "react-router-dom";
import { ButtonEdit, ButtonDetail, ButtonDelete } from "../common/Button"

export function NoticeCardAdmin(props) {
    return (
        <div class="card" key={props.index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{props.object.noticeTitle}</h4>
                <p class="card-text">{props.object.noticeContent.replace( /(<([^>]+)>)/ig, '')}</p>
                <ButtonDetail id={props.object.id} url={"/notice_admin?id="}/>
                <ButtonEdit id={props.object.id} url={"/notice_modi_admin?id="}/>
                <ButtonDelete id={props.object.id} url={"/delete/notice"}/>
            </div>
        </div> 
    );
}